<div class="modal-header">
  <span class="header">{{ action }} test</span>
  <i class="mdi mdi-close close-icon" mat-dialog-close></i>
</div>
<hr class="header-border" />
<div class="status-container">
  <div *ngIf="isLoading">
    <div class="loader">
      <mat-spinner></mat-spinner>
    </div>
    <div class="loader-message">{{ loaderMessage }}</div>
  </div>
  <div *ngIf="!isLoading">
    <div class="row">
      <div
        class="circle"
        [ngClass]="{
          success: !isRequestFailed,
          failed: isRequestFailed
        }"
      >
        <i class="status-icon" [ngClass]="icon"></i>
      </div>
    </div>
    <div class="success-message">{{ message }}</div>
    <div class="font-14" *ngIf="navigateToPage">
      You can monitor its results from the
      <a class="test-list-link" (click)="navigateToTestListPage()">Test list</a>
      page.
    </div>
    <div *ngIf="isRequestFailed" class="font-14">
      {{ errorDescription }}
    </div>
    <div class="table-container" *ngIf="bulkErrors && bulkErrors.length > 0">
      <table>
        <tr>
          <th>Test</th>
          <th>Issue</th>
        </tr>
        <tr *ngFor="let error of bulkErrors">
          <td>{{ error.name }}</td>
          <td>{{ error.issue }}</td>
        </tr>
      </table>
    </div>
    <div class="close">
      <button mat-flat-button mat-dialog-close>CLOSE</button>
    </div>
  </div>
</div>
